<template>
  <fb-list-body :pager="pager"
                @handlePagerSizeChange="handlePagerSizeChange"
                @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('add')">{{ $t('lang.新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>

    <template slot="search-form">
      <el-form-item :label="$t('lang.标题')">
        <el-input clearable />
      </el-form-item>

      <el-form-item class="search-form-item" label="">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
        <el-button size="mini" @click="handleReset">{{$t('lang.重置')}}</el-button>
      </el-form-item>
    </template>


    <template slot="table">

      <el-table :data="tableData" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" :label="$t('lang.序号')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.标题')"></el-table-column>
        <el-table-column prop="pid" label="pid"></el-table-column>
        <el-table-column prop="model" :label="$t('lang.型号')"></el-table-column>
        <el-table-column prop="brandOwnerName" :label="$t('lang.品牌商名称')"></el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.创建时间')">
          <template v-slot="{row}">
            {{$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')}}
          </template>
        </el-table-column>


        <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
          <template v-slot="{row}">
            <el-button size="mini"
                       @click="$router.push('detail?code=' + row.code)"
                       plain  type="primary">
              {{ $t('lang.查看') }}</el-button>
            <el-button size="mini"
                       @click="$router.push('edit?code=' + row.code)"
                       plain  type="primary">
              {{ $t('lang.编辑') }}</el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

  </fb-list-body>
</template>

<script>
export default {
  name: "BannerList",
  components: {},
  data() {
    return {
      api: {
        list: this.$api.banner.list,
        delete: this.$api.banner.delete,
        batchDelete: this.$api.banner.batchDelete,
      },
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      time: ''
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();
      },
      deep: true
    }
  },
  methods: {
    handleReset() {

    },

    handleEdit(e) {
      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {
      let vm = this;
      vm.$confirm(vm.$t(`lang.您现在正在进行删除操作`), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {
        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })
      }).catch(() => {});

    },
    handleBatchDelete() {
      let vm = this;
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }
      let codes = this.selection.map(item => item.code);
      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })
      }).catch(() => {});
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },

    handleSearch() {
      let vm = this;
      let data = {...this.searchParams};
      this.$http.post(this.api.list, this.$qs.stringify(data)).then((resp) => {
        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }
        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;
      })
    }
  },
  created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
